module.exports = __webpack_public_path__ + "static/media/icon-arrow.df5a006c.svg";